export const TeamsData = [
  {
    CreatorTeams:[{
    TeamName: "창작진",
    TeamDescription:
      "창작 뮤지컬 <프로젝트 용궁 : 낙원의 미스테리>에 생명력을 불어넣은 창작진!\n창작진은 몰입도 있고, 퀄리티 좋은 작품을 만들기 위해 오랜 시간동안 노력해왔습니다.\n매력적인 글과, 환상적인 음악을 함께 즐겨주시면 감사하겠습니다!",
      TeamHead: "총괄 프로듀서 / 작가",

      TeamMembers: [
        {
          Name: "김수민",
          Image: "창작진/김수민.jpeg",
          Words: "", 
          Works: ["총괄 프로듀서 / 작가"],
          Insta: "charlotte_lool",
        }
      ],
    },
    {
      
      TeamName: "창작진",
      TeamDescription:
      "창작 뮤지컬 <프로젝트 용궁 : 낙원의 미스테리>에 생명력을 불어넣은 창작진!\n창작진은 몰입도 있고, 퀄리티 좋은 작품을 만들기 위해 오랜 시간동안 노력해왔습니다.\n매력적인 글과, 환상적인 음악을 함께 즐겨주시면 감사하겠습니다!",
      TeamHead: "극작",

      TeamMembers: [
        {
          Name: "조경민",
          Image: "창작진/조경민.jpeg",
          Words: "유혈액션 SF 환승연애 도플갱어 호러 증강현실 동양풍 뮤지컬을 쓰겠다는 욕망에 이끌려 여기까지 왔습니다. 멋쟁이 새벽인들 고생 많았어요! <용궁> 브로드웨이 입성 & 스팀 입점하는 그날까지 화이팅~!",
          Works: ["극작"],
          Insta: "fantabulous_min"
        },
        {
          Name: "이채윤",
          Image: "창작진/이채윤.jpeg",
          Words: " 오랜 준비 끝에 용궁이 드디어 무대에 올라 관객분들과 만나게 되네요. 말 그대로 가상의 세계에만 있던 용궁이 현실화되기까지 애써주신 모든 분들 감사합니다. 긴 시간 동안 놓지 않았던 이 마음 잊지 않고, 앞으로도 좋아하는 것들을 계속 좋아하며 살아가요 우리.",
          Works: ["극작"],
          Insta: "petit_madeleine",
        },
      ],

    },
    {
      
      TeamName: "창작진",
      TeamDescription:
        "창작 뮤지컬 <프로젝트 용궁 : 낙원의 미스테리>에 생명력을 불어넣은 창작진!\n창작진은 몰입도 있고, 퀄리티 좋은 작품을 만들기 위해 오랜 시간동안 노력해왔습니다.\n매력적인 글과, 환상적인 음악을 함께 즐겨주시면 감사하겠습니다!",
      TeamHead: "작곡 / 음악감독",

      TeamMembers: [
        {
          Name: "이정아",
          Image: "음악팀/이정아.jpeg",
          Words: "학부 시절의 가장 소중한 기억을 함께했던 친구들과 ‘우리가 직접 극을 만들어 보자’ 이야기한 것이 이 공연의 첫 출발이었습니다. 처음에는 연극을 구상하다가 뮤지컬로 노선을 변경하였을 때, 걱정이 밀려오면서도 한편으로는 기대감에 잔뜩 부풀어 있던 순간이 떠오르네요. 서양 클래식 음악, 특히 기악 음악 바탕의 공부를 해 온 저에게 뮤지컬 작곡은 일종의 일탈이자 도전이었습니다. 음악감독으로 배우들의 노래를 지도하는 과정 역시 다른 창작곡 리허설과는 많이 달랐습니다. 무엇보다 공연 제작 메커니즘이 완전히 다른데, 저에게 음악 관련 전권을 오롯이 맡겨준 수민이 덕분에 제 안의 소리를 마음껏 펼칠 수 있었습니다.\n\n오늘 이 모든 것이 가능하게 한 총괄 수민이에게 정말 대단하고, 고맙다는 말을 전하고 싶습니다. 그리고 손 많이 가는 MR 작업을 흔쾌히 도와준 지인이에게 너무나 고맙습니다. 맡은 자리에서 최선을 다한 ‘창작집단 새벽’의 모든 구성원께, 이 작품을 공연에 올리기까지 여러 모양으로 마음 쏟아주어 감사하다는 인사를 드립니다. 선물 같았던 프로젝트 용궁과 함께한 사람들, 또 만나게 되면 좋겠습니다.", 
          Works: ["작곡 / 음악감독"],
          Insta: "",
        },
      ],
    }
    ]
  },

  {
    TeamName: "연출팀",
    TeamDescription:"연출팀은 극을 하나로 이끌어가는 역할을 합니다. 각 장과 대사의 의미를 분석하고 극의 방향성을 결정합니다. 이를 기반으로, 극의 메시지를 가장 효과적으로 구현해내기 위한 모든 동선과 다양한 연출 방식을 구상합니다. 더하여 배우들의 연기, 안무 지도 및 각 장면의 연출을 맡으며 의상, 조명, 분장, 소품, 크루 등의 업무를 담당합니다. 연출팀은 극의 모든 영역에 참여하여, 극의 방향이 일관되게 흘러갈 수 있도록 노력합니다.",
    TeamHead: "총연출",
    useDoubleHead : true,
    TeamMembers: [
      {
        Name: "김나래",
        Image: "연출팀/김나래.png",
        Words: 
        "안녕하세요. 총연출 김나래입니다.\n"
        +"<프로젝트 용궁>에 로그인해주신 모든 관객분께 감사드립니다.\n"
        +"오빠의 희미한 흔적을 찾아 용궁에 뛰어든 재이와 함께 관객분들께서도 용궁을 같이 탐험하며 재미있는 시간을 보내셨길 바랍니다.\n\n"
        
        +"이 극을 올리기까지, 그리고 제가 이 자리에 있기까지 정말 많은 사람의 도움이 있었습니다. \n"
        +"극의 형체가 분명하지 않을 때부터 막연한 부탁을 청해도, 망설임 없이 도움을 주신 분들께 진심을 다해 감사드립니다. 부족한 저를 믿어주고, 제가 직접 볼 수 없는 각자의 자리에서도 최선을 다해주어 정말 감사했습니다. 여러분의 소중함과 감사함을 잊지 않고 꼭 보답하겠습니다.\n\n"
        
        +"이번 연출은 저에게 큰 도전이었습니다. 현실과의 타협은 멀리하고, 좋은 텍스트를 비어있는 무대에 차곡차곡 구현해내는 것은 많은 고뇌와 설득을 필요로 했습니다.\n"
        +"그럼에도, 이 모든 과정을 같이 걸어온 우리 연출팀.\n"
        +"가리워진 길에 불을 밝혀줘서, 함께해줘서 행복했습니다.\n"
        +"저에게 연출은 영원한 자부심으로 남아 있을 거예요. \n\n"
        
        +"영국의 조그마한 방에서 해리포터 책을 꺼내 보이며 처음 연출 회의를 시작했던 그 순간부터 글을 쓰는 지금까지의 모든 순간이 기억에 남습니다. \n"
        +"<프로젝트 용궁>을 통해 또 하나의 찬란한 추억을 만들 수 있어서 행복했습니다. \n"
        +"그렇다면, 이제 시스템 세이브. 로그아웃 요청\n",
        Works: ["총연출"],
        Insta: "",
      },
      {
        Name: "김유진",
        Image: "디자인팀/김유진.jpg",
        Words: 
        "안녕하세요, 프로젝트 용궁의 안무감독 김유진입니다. ‘그 남자의 죽음’, ‘튜토리얼’, ‘목련의 춤’, ‘이 사랑 계속되길’의 안무를 맡았습니다. 전공과 무관하게 춤을 추는 일을 언제나 즐겨왔는데, 믿고 의지하는 동료들과 함께 만드는 작품에 안무로 참여하게 되어 영광이었습니다. 춤을 추는 연출팀원이라는 이유로 시작했던 일에 거창한 이름이 붙어 부담도 느꼈지만, 값진 기회였음이 분명합니다. 춤을 위한 춤이 아닌, 노래 그리고 연기와 동행하는 움직임 - 한 명의 내가 아닌, 다수의 타인이 완성할 춤에 대해 고민해 볼 수 있는 시간이었습니다. 용궁의 끝이 보이는 이제서야 이 일에 대해 손톱만큼이나마 알 것 같습니다. 사건은 그곳을 벗어나야만, 시간은 그때를 흘려보내야만 비로소 이해됩니다. 용궁을 만드는 일이 얼마나 가치 있는 일이었는지도 이 시간이 지나면 더 깊이 알게 될 듯합니다.\n\n"
        +"창작과 예술, 무대를 사랑하고, 또 나와 같은 마음의 사람들과 함께하는 것을 사랑한다는 것을 다시 깨닫습니다. 부족함이 많은 저를 믿고 무대를 완성해 준 배우님들, 같이 움직임에 대해 고민해준 연출팀, 용궁의 모든 팀원, 그리고 특히 우리팀 시연, 나영, 수빈 너무 고맙습니다! 또한 공연 제작에 도움을 주신 학교 내외의 모든 분들, 또 용궁을 완성하러 와주신 관객 여러분께 큰 감사드립니다.\n\n",
        Works: ["안무감독"],
        Insta: "92o_silver",
      },
      {
        Name: "전종원",
        Image: "연출팀/전종원.jpg",
        Words: 
        "좋은 분들과 함께였기에 첫 연출임에도 많이 배우고 성장할 수 있었습니다. 행복했던 3개월의 여정 동안 텍스트를 무대에 구현하기 위해 치열하게 고민한 연출팀의 흔적이 관객 여러분들께 전달되기를 바랍니다. \n시스템 세이브, 로그아웃 요청.",
        Works: ["조연출","조명(디자인 및 오퍼레이션)","크루"],
        Insta: "broccoli_lucas",
      },
      {
        Name: "김현정",
        Image: "연출팀/김현정.jpg",
        Words: "보러 와주신 모든 분들, 감사합니다. 현실보다 달콤하고 현실보다 더 진짜 같은 저희 공연을 통해 선물 같은 시간 보낼 수 있기를 바랍니다.",
        Works: ["조연출", "의상/분장", "소품","크루"],
        Insta: "cherish_hyum",
      },
      {
        Name: "김수민",
        Image: "연출팀/김수민.jpeg",
        Words: " 창작극 연출은 두번째인데, 이거이거 할수록 어려운 것 같습니다!!! 나래 종원 현정이랑 같이 연출해서 즐거웠어요 흐흐 배우님들도 만나서 너무 반가웠습니다!",
        Works: ["조연출", "조명(디자인 및 오퍼레이션)"],
        Insta: "charlotte_lool",
      },
      {
        Name: "하소진",
        Image: "연출팀/하소진.jpeg",
        Words: "이번 <용궁> 공연을 함께 준비할 수 있어서 영광이었고 행복했습니다! 함께 준비하고 연습하느라 애써준 사람들 모두 고맙고 수고했어요 ‪❤︎ 감사합니다!!",
        Works: ["크루","의상/분장"],
        Insta: " rrkaqlajdajd",
      },
      {
        Name: "이상헌",
        Image: "연출팀/이상헌.jpg",
        Words: "안녕하세요!! 크루 부부팀장 이상헌입니다~ 충격적이고 위험한 비밀이 숨겨진 게임 용궁 함께 해요🥺",
        Works: ["크루"],
        Insta: " ",
      },
      {
        Name: "김영애",
        Image: "연출팀/김영애.jpg",
        Words: "좋아하는 일을 할 때에만 비로소 느낄 수 있는 그 짜릿함을 다시 한번 느끼게 해주셔서 감사합니다:) 작게나마 제가 공연에 도움이 되었길 바랍니다. 멋진 공연에 함께 할 수 있어서 영광이었습니다! ",
        Works: ["크루"],
        Insta: " ",
      },
      {
        Name: "진유영",
        Image: "연출팀/진유영.jpg",
        Words: "공연에 몰입하실 수 있도록 백스테이지에서 열일하고 있겠습니다!\n뜻깊은 경험을 하게 해준 현정누나에게 고마움을 전합니다.\n즐거운 관람 되세요*^~^*",
        Works: ["크루"],
        Insta: " ",
      },
    ],
  },
  
  {
    TeamName: "음악팀",
    TeamDescription:
      "음악팀은 이번 공연을 위해 제작한 MR과 효과음을 관리하고, 배우들의 노래 연습을 지도합니다. 공연 현장에서 음향을 체크하는 역할도 담당합니다.",
    TeamHead: "작곡가/음악감독",

    TeamMembers: [
      {
        Name: "이정아",
        Image: "음악팀/이정아.jpeg",
        Words: "안녕하세요, <프로젝트 용궁: 낙원의 미스테리> 곡을 쓴 이정아입니다.\n\n"
              +"학부 시절의 가장 소중한 기억을 함께했던 친구들과 ‘우리가 직접 극을 만들어 보자’ 이야기한 것이 이 공연의 첫 출발이었습니다. 처음에는 연극을 구상하다가 뮤지컬로 노선을 변경하였을 때, 걱정이 밀려오면서도 한편으로는 기대감에 잔뜩 부풀어 있던 순간이 떠오르네요. 서양 클래식 음악, 특히 기악 음악 바탕의 공부를 해 온 저에게 뮤지컬 작곡은 일종의 일탈이자 도전이었습니다. 음악감독으로 배우들의 노래를 지도하는 과정 역시 다른 창작곡 리허설과는 많이 달랐습니다. 무엇보다 공연 제작 메커니즘이 완전히 다른데, 저에게 음악 관련 전권을 오롯이 맡겨준 수민이 덕분에 제 안의 소리를 마음껏 펼칠 수 있었습니다.\n\n"        
              +"오늘 이 모든 것이 가능하게 한 총괄 수민이에게 정말 대단하고, 고맙다는 말을 전하고 싶습니다. 그리고 손 많이 가는 MR 작업을 흔쾌히 도와준 지인이에게 너무나 고맙습니다. 맡은 자리에서 최선을 다한 ‘창작집단 새벽’의 모든 구성원께, 이 작품을 공연에 올리기까지 여러 모양으로 마음 쏟아주어 감사하다는 인사를 드립니다. 선물 같았던 프로젝트 용궁과 함께한 사람들, 또 만나게 되면 좋겠습니다.",
        Works: ["작곡","음악감독"],
        Insta: "leeja0308",
      },
      {
        Name: "김상은",
        Image: "음악팀/김상은.jpeg",
        Words: "용궁이라는 공연에 참여하게 되어, 정말 오랜만에 뮤지컬 작업 함께하게 되어 참 영광스럽습니다! 좋아하는 사람들과, 또 멋진 배우분들 및 스태프 분들과 열심히 준비하였으니 관객 분들께서도 많이 봐주시고 좋아해주시면 감사하겠습니다 :) 콘솔에서 뵐게요. 용궁 화이팅!",
        Works: ["음향"],
        Insta: "imagine__1011",
      },
      {
        Name: "강서진",
        Image: "음악팀/강서진.jpeg",
        Words: "안녕하세요, 서울대학교 작곡과 1학년에 재학중인 강서진입니다. 좋은 기회로 뮤지컬 <용궁>에 스텝으로 참여하게 되어 너무나 값진 경험이 되었습니다!",
        Works: ["음악 연습 보조"],
        Insta: "" ,
      },
    ],
  },
  {
    TeamName: "경영지원",
    TeamDescription:
      "경영지원팀은 무대 밖 전반의 일을 담당합니다. 공연장 대관부터 리크루팅 및 연습 지원, 각종 시설 예약, 예산 마련, 티켓 오픈과 공연장 관리까지 공연이 원활하게 이루어질 수 있도록 각종 업무를 진행합니다. 또한 여러 팀들과의 소통을 통해 각 팀의 운영을 지원합니다.",
    TeamHead: "경영지원팀장",
    useDoubleHead : true,

    TeamMembers: [
      {
        Name: "김은희",
        Image: "경영지원팀/김은희.jpg",
        Words: 
        "안녕하세요. 경영지원 팀장 김은희입니다. 재미있는 프로젝트를 함께해보자는 말에 덜컥 시작해버린 <프로젝트 용궁: 낙원의 미스테리>는 그 제목처럼 저에게 낙원 같기도, 미스테리 같기도 했습니다. \n"
        +"저는 어린 아이였을 때부터 공연기획자가 되기를 꿈 꿨기에, 창작집단 새벽을 시작하고 경영지원팀이 되었을 때 저의 꿈에 한걸음 더 다가간 것만 같아 낙원을 만난 듯 설레었습니다. 그러나 시간이 지나 점차 어린 시절 꿈을 포기하게 되었고, 저의 시작인 줄 알았던 이번 공연은 미스테리하게도 저의 마지막 공연이 될 것 같아 개인적으로 더욱 애틋하고 특별합니다.\n"
        +"너무나도 부족한 팀장임에도 괜찮다고 다독여주며, 각자 맡은 일을 알아서 척척 잘해준 우리 경영지원팀 영민이, 경민이, 재윤이에게 특히나 미안하고 고맙습니다.\n"
        +"또 저의 고민을 들어주며 함께해온 채윤언니, 정아, 나래에게도 고맙습니다. 무엇보다 가장 고생했을 수민이, 이번 작품을 제안해주고, 모든 과정에 함께해주고, 포기하지 않을 수 있도록 응원해줘서 진심으로 고맙다는 말을 전합니다.\n"
        +"가장 사랑하는 사람들과 가장 사랑하는 일을 할 수 있다는 것은 저에게 축복이자 자부심이었습니다. <프로젝트 용궁: 낙원의 미스테리>에 함께할 수 있어 행복했습니다. 그런 저의 행복이 관객 여러분에게도 전해지길 바랍니다",
        Works: ["경영지원팀장"],
        Insta: "",
      },
      {
        Name: "지영민",
        Image: "경영지원팀/지영민.jpeg",
        Words: 
        "안녕하세요. 회계 지영민입니다. 대학 생활 중 가장 큰 부분을 차지했던 뮤지컬 세 편을 올리고, 이제는 더 이상 공연을 올릴 일이 없겠구나 하는 서글픈 생각이 들 때쯤, 같이 작품을 하던 친구들이 <프로젝트 용궁 : 낙원의 미스테리>를 들고 찾아왔습니다. 그렇게 홀린 듯이 또 한 번의 여름을 뮤지컬에 내어주었습니다.\n"
        +"이번 작품은 새로운 뮤지컬을 세상에 내보인다는 보람이 특히 컸습니다. 대본으로만 봐도 매력적으로 보였던 가상현실 용궁 세계를, 무대 장치를 통해 현실 공간에 구현하고, 캐릭터에 숨을 불어넣는 과정을 보는 일은 무척 즐거웠습니다. 각 분야에서 전문적인 경험을 쌓아온 친구들이 힘을 합쳐 작품을 조각조각 채워나가는 일이 멋있었고, 이 과정의 한 부분을 맡을 수 있어서 영광이었습니다.\n"
        +"처음 해보는 일이라 버벅거림이 많았지만 함께 고민해 주고, 그때그때 요청하는 일들을 척척 처리해 준 은희, 경민이, 재윤이에게 고마움을 전하고 싶습니다. 또, 부족함이 많았지만 믿고 맡겨준 수민이, 열심히 협력해 준 나래, 정아, 수빈, 예진님에게 감사하다는 말을 전합니다. \n"
        +"마지막으로 <프로젝트 용궁 : 낙원의 미스테리>를 보러 와주신 관객 여러분께 감사드리며, 신비하면서도 매력적이고 아름다우면서도 일그러진 <용궁> 세계에 풍덩 빠져보시길 바랍니다. \n",
  
        Works: ["회계담당"],
        Insta: "",
      },
      {
        Name: "권재윤",
        Image: "경영지원팀/권재윤.jpeg",
        Words: "공연과 문화에 관심이 많은 서울대학교 학우분들과 함께 창작 뮤지컬을 함께 만들어갈 수 있어 뜻깊은 것 같아요. 연습 과정이 힘들었지만 공연이 무사히 마무리되어 의미 있는 추억으로 남았으면 좋겠습니다. 창작 뮤지컬 용궁 많이 사랑해 주세요!",
        Works: ["기획팀 소속 예약담당 및 오디션 지원"],
        Insta: "k_kokomong",
      },
      {
        Name: "김경민",
        Image: "디자인팀/김경민.jpg",
        Words: "정신을 차려보니 또 뮤지컬을 하고 있네요! 하하\n새벽 구성원들의 애정 어린 손길이 곳곳에 닿아있는 극이니 두 눈과 귀로 마음껏 즐겨주세요~~!",
        Works: ["디자인 담당"],
        Insta: "kmmin_g",
      },
    ],
  },
  {
    TeamName: "디자인",
    TeamDescription:
      "디자인팀은 공연에 사용되는 시각적 요소 전반을 담당합니다. 포스터 디자인부터 티켓 제작, 그리고 온라인 플북 제작 업무를 합니다. 또 홍보팀과 협업하며 각종 콘텐츠 발행 및 굿즈 제작을 담당합니다.",
    TeamHead: "디자인감독",

    TeamMembers: [
      {
        Name: "김경민",
        Image: "디자인팀/김경민.jpg",
        Words: 
        "재작년 두 차례의 공연을 올리고 공연에 대한 한은 다 풀었다 생각했는데 또 뮤지컬을 하고 있네요. 더 이상 미련 없다 생각했지만 사실 그때의 열정 넘치던 제가 그리웠던 것 같기도 합니다. 공연이라는 것이 늘 그렇듯 순탄치 많은 않았던 것 같습니다. 그럼에도 하나씩 완결을 지을 때마다 넘치게 뿌듯했고, 머릿속에만 있던 용궁을 실체화하는 과정을 함께할 수 있어 행복했습니다.\n"
        +"먼저 방학부터 지금까지 함께 열심히 달려준 호찬이, 멋진 포스터를 만들어주신 유진님, 급한 요청이었는데도 선뜻 도움의 손길을 내어 준 아영이까지 얼레벌레 팀장이었지만 각자의 몫을 다해준 디자인팀에게 정말 고맙습니다!\n"
        +"또 저는 거의 유령회원으로 있었지만 각자의 자리에서 훌륭했던 기획팀의 은희언니, 영민언니, 재윤님, 무대 제작을 함께한 수빈님과 협업해 준 나래님, 예진님, 정아 마지막으로 이 모든 것을 위해 그 누구보다 달렸을 수민이까지! 모두에게 진심을 담아 감사 인사를 전합니다.\n\n"
        +'끝으로 <프로젝트 용궁 : 낙원의 미스테리>을 보러 와주신 모든 분들께 감사드리며, "현실보다 더 달콤하고 현실보다 더 진짜 같은" 용궁의 세계에 매료되시길 바랍니다.\n',
        Works: ["디자이너"],
        Insta: "kmmin_g",
      },
      {
        Name: "김유진",
        Image: "디자인팀/김유진.jpg",
        Words: "진정 동고동락한 연출팀, 척하면 척 나의 짱안무팀, 랜선미대연대 디자인팀, 그리고 용궁을 만든 모든 분들 정말 고맙습니다! 저에게는 길고도 짧은 제 학부 생활이 총망라된 프로젝트입니다. 관객으로서 극을 완성해 주신 여러분께 감사하며, 모두의 현실이 아름답기를!",
        Works: ["포스터 디자인"],
        Insta: "92o_silver",
      },
      {
        Name: "방호찬",
        Image: "디자인팀/방호찬.jpg",
        Words: "정신을 차려보니 용궁 멤버가 되어버렸네요. 작년에 작게 모여 극을 쓰던 팀이 어느새 커다란 창작 집단이 되어 있다니 놀랍고 자랑스럽네요 :) 멋진 친구들이 진심으로 준비한 극 재미있게 봐주세요!",
        Works: ["웹페이지 제작"],
        Insta: "shooting__staa",
      },
      {
        Name: "황아영",
        Image: "디자인팀/황아영.jpg",
        Words: "요리 왕이 되고 싶다",
        Works: ["굿즈 디자인"],
        Insta: "dkdkdud333",
      },
    ],
  },
  {
    TeamName: "홍보팀",
    TeamDescription:
      "안녕하세요, 창작집단 새벽의 홍보팀입니다. 인스타그램, 유튜브 계정 관리 및 SNS 콘텐츠 발행과 관련된 전반적인 업무를 맡고 있습니다.",
    TeamHead: "홍보팀장",

    TeamMembers: [
      {
        Name: "계예진",
        Image: "홍보팀/계예진.jpeg",
        Words: "안녕하세요 계예진입니다. 홍보팀은 연출 팀장님의 권유로 뒤늦게 프로젝트 용궁을 함께하게 되었는데요, 이렇게 멋진 사람들이 많은 프로젝트에 합류하게 되어 영광입니다. 저는 뮤지컬을 만드는 일에 대해서는 잘 모르지만 뮤지컬을 보러 가는 것은 좋아합니다. 그 중에서도 배우와 모든 앙상블이 나와 오프닝으로 무대를 여는 장면을 가장 좋아하는데요. 항상 그 시작을 보면 가슴이 떨리고 괜히 눈물이 울컥 올라옵니다. 연기와 무대연출과 음악이 모두 삼박자로 맞아떨어지는 순간에 대한 감동과 이를 만들어 낸 사람들에 대한 존경 같은 감정들이 한 번에 몰려오기 때문인 것 같아요. 무언가를 사랑하는 사람들이 모여 함께 하나의 작품을 만드는 일은 언제나 멋진 일인 것 같습니다. 프로젝트 용궁을 만들기 위해서도 정말 많은 사람들이 함께 하고 있는데요. 저는 그 중에서도 광고를 사랑하는 사람으로 작품에 기여할 수 있게 되어 즐거운 마음으로 작업하고 있습니다. 누구나 한 번쯤 용궁처럼 모든 것이 완벽한 낙원을 상상해 본적이 있지 않나요? 정말로 근미래에 용궁과 같은 게임이 출시된다면 가장 먼저 즐겨보고 싶습니다. 프로젝트 용궁이 작품에 참여한 사람들과 작품을 보러 온 사람들 모두에게 기억될 만한 좋은 작품으로 남길 바랍니다. 많은 관심 부탁드려요!",
        Works: ["홍보팀장","유튜브 계정 관리 및 콘텐츠 발행"],
        Insta: "egg_yejin",
      },
      {
        Name: "강예은",
        Image: "홍보팀/강예은.jpeg",
        Words: "노는게 제일 좋아 친구들 모여라",
        Works: ["유튜브 콘텐츠 기획 및 디자인"],
        Insta: "0l.19__",
      },
      {
        Name: "오재원",
        Image: "홍보팀/오재원.jpeg",
        Words: "배우 인스타그램 계정 관리 및 콘텐츠 발행",
        Works: ["미지의 용궁을 향해서"],
        Insta: "5re__1",
      },
      {
        Name: "박서영",
        Image: "홍보팀/박서영.jpeg",
        Words: "용궁 화이팅!",
        Works: ["창작집단 새벽 인스타그램 계정 관리 및 콘텐츠 발행"],
        Insta: "zo__glasss",
      },
    ],
  },
  {
    TeamName: "무대팀",
    TeamDescription:
      "무대팀은 <프로젝트 용궁 : 낙원의 미스테리>가 펼쳐질 모든 공간을 제작하고 표현하는 팀이다. 공연의 다양한 동선과 여러 시각적 효과를 구현하는 모든 무대세트를 위해 오랜 기간동안 고군분투 한 무대팀은 작화를 담당한 서양화과 학생들과 세트제작을 담당한 건축학과 학생들을 포함하여 총 11명으로 구성되어있다.",
    TeamHead: "무대감독",

    TeamMembers: [
      {
        Name: "김수빈",
        Image: "무대팀/김수빈.jpeg",
        Words: "안녕하세요 <창작집단 새벽>의 무대 제작 총괄 김수빈입니다. \n\n"
        +"무대설계부터 실사제작 그리고 세트의 작동까지 모두 담당하게 되면서 아주 긴 시간동안 <프로젝트 용궁 : 낙원의 미스테리>의 무대제작에 참여하였습니다. \n\n"
        +"<프로젝트 용궁 : 낙원의 미스테리>는 그 작품의 세계관이 평범한 일상을 넘어 게임 속 미스테리한 배경을 아우르고 있는데 이를 모두 커버할 수 있는 세트를 디자인하기 위해 헤더진들과의 고심끝에 지금과 같은 구조와 작화의 방향성을 잡았습니다. \n\n"
        +"<창작집단 새벽>에 무대팀장으로 합류하게 되면서 학생작품이지만 매우 큰 스케일의 무대디자인을 의뢰받았습니다. 각각 3m*2.5m 크기의 회전벽 2개와 3개의 미닫이벽을 작동시켜야 했고 동시에 그 모든 벽들이 하나로 연결된 프레임을 제작해야했으므로 세부적인 구조와 맞물리는 모든 접합부에 대한 건축적인 고민이 많았습니다. 오랜 제작기간 끝에 이로써 결국 무대가 완성되었으니 이들이 과연 어떻게 움직이는지 지켜봐주시면 감사하겠습니다.",
        Works: ["무대감독"],
        Insta: "shine.sovv",
      },
      {
        Name: "김경민",
        Image: "디자인팀/김경민.jpg",
        Words: "정신을 차려보니 또 뮤지컬을 하고 있네요! 하하\n"
            +"새벽 구성원들의 애정 어린 손길이 곳곳에 닿아있는 극이니 두 눈과 귀로 마음껏 즐겨주세요~~!",
        Works: ["무대 디자인 총괄/작화"],
        Insta: "kmmin_g",
      },
      {
        Name: "최나음",
        Image: "무대팀/최나음.jpeg",
        Words: "뮤지컬에 진심인 사람들이 모녀 열심히 제작한 극입니다! 배경 작화도 눈으로 재밌게 즐겨주세요:)",
        Works: ["작화"],
        Insta: "better_the_naeum",
      },
      {
        Name: "조수민",
        Image: "무대팀/조수민.png",
        Words: "짧은 시간이지만 작화로 참여했습니다. 극 뿐만 아니라 무대도 예쁘게, 잘 봐주시면 감사하겠습니다 :)",
        Works: ["작화"],
        Insta: "_soom_in__",
      },
      {
        Name: "최재영",
        Image: "무대팀/최재영.jpeg",
        Words: "저는 용궁 같은 뮤지컬 프로젝트에 참여해 보는 것이 이번이 처음이었습니다. 이 과정에서 하나의 뮤지컬을 올리는데 정말 많은 사람의 많은 노력이 필요하다는 점을 알게 되었습니다. 무대를 제작하는 것이 힘들기도 했지만 그만큼 성취감도 느낄 수 있었던 프로젝트였습니다!",
        Works: ["무대 제작"],
        Insta: "young007",
      },
      {
        Name: "김서연",
        Image: "무대팀/김서연.jpeg",
        Words: "처음에는 어디서도 경험할 수 없는 좋은 기회라고 생각하여 경험에 의미를 두고 가볍게 시작했지만, 단순히 경험을 넘어 소중한 시간이 되었습니다. 좋은 사람들을 만나 즐겁게 작업하였고, 작업하면서 새로운 것들을 많이 배울 수 있었습니다. 그래서 이 프로젝트에 참여할 수 있어서 영광이었고 소중한 추억이 될 것 같습니다.",
        Works: ["무대 제작"],
        Insta: "ksy_12321",
      },
      {
        Name: "허유나",
        Image: "무대팀/허유나.jpeg",
        Words: "안녕하세요 용궁 무대제작에 참여한 건축학과 23학번 허유나입니다. 건축학과에 들어오면 무대제작을 꼭 해보고 싶었는데 이번 기회로 많은 것들을 배우고 직접 해볼 수 있어 감사한 시간을 보낸 것 같습니다. 팀원분들의 노력이 뮤지컬을 통해 많은 분들께 즐거움으로 전달되면 좋겠습니다!",
        Works: ["무대 제작"],
        Insta: "pethrichyorn",
      },
      {
        Name: "편서영",
        Image: "무대팀/편서영.jpeg",
        Words: "처음엔 무대제작에 대해서 모르고 그냥 재밌겠다라는 마음으로 시작했는데 하다보니, 좁은 무대와 제한된 요소로 장면을 연출하기 위한 고정장치나 회전장치들에 대해 알게되어 재밌는 시간이었습니다 ~~",
        Works: ["무대 제작","작화"],
        Insta: "s._.y._.0",
      },
      {
        Name: "김태준",
        Image: "무대팀/김태준.jpeg",
        Words: "안녕하세요 프로젝트 용궁의 무대제작에 참여한 건축학과 23학번입니다! 학교 수업에서만 하는 프로젝트만 하다보면 할 수 없는 무대제작이라는 활동을 하게 되어 뜻 깊고 많은 것을 배울 수 있었습니다! 같이 제작한 팀원들과 팀장님이신 수빈선배,작화팀 모두 수고하셨습니다!",
        Works: ["무대 제작"],
        Insta: "lifeishanbang",
      },
      {
        Name: "김정훈",
        Image: "무대팀/김정훈.jpeg",
        Words: '"전공은 뮤지컬이고, 부전공은 건축입니다." 제가 배운 것들을 활용해 뮤지컬을 참여할 수 있다는 사실이 영광스러운 하루입니다! 회전문에 슬라이딩 벽까지.. 쉬운 것 하나 없었지만, 열심히 만든 극의 무대를 집중해서 봐주세요! 사랑합니다, 관객 여러분!',
        Works: ["무대 설계 총괄","제작","작화"],
        Insta: "kllo_at",
      },
      {
        Name: "조영서",
        Image: "무대팀/조영서.jpeg",
        Words: '함께한 무대팀을 비롯해 모두 정말 수고 많으셨습니다!',
        Works: ["무대 제작"],
        Insta: "lukyxul",
      },
    ],
  },
];

export const ActorData = [
  {
    Name: "공현비",
    Image: "배우팀/공현비.jpg",
    Role: "윤재이",
    Words: "“오빠를 위해 시작했던 도전, \n이번엔 꼭 살릴거야.”",
    Description:"한때 최고의 프로게이머였던 재이. 정이 많고 감정이 풍부하지만, 표현하는 게 어색해 툴툴거리기도 하고 말이 공격적일 때도 있다. 오빠 윤지운의 자살 사건 후 2년이 지났지만, 여전히 오빠를 그리워한다. 오빠의 죽음에 대해 알고 싶어 찾아간 곳에 오빠로 인한 슬픔과 아픔을 간직한 사람의 이야기를 듣고 도움을 주기로 결심한다.",
    Questions:[
      {
        Q:"자기소개 부탁드립니다!",
        A:"안녕하세요 이번 <프로젝트 용궁: 낙원의 미스테리>에서 윤재이 역할을 맡은 공현비입니다.\n"
        +"다양한 창작뮤지컬을 하면서 내가 처음으로 만드는 캐릭터에 매력을 느껴 이번 작품의 참여를 하게 되었습니다. 미래에 대해 이야기하는 작품이기도 하고 판타지적 요소로 어려운 점도 있었지만 인물과 작품에 대한 다양한 의견을 들으며 우리가 살아가는 사회는 얼마나 복잡한 지에 대해서 많이 느끼게 된 작품이었습니다. \n"
        +"찾아주신 관객여러분께 감사하다는 말씀드리며 우리가 하고 있는, 하게 될 모든 사랑의 형태에 대해 최선을 다하기를 응원합니다."
        
      },
      {
        Q:"본인의 오빠(윤지운)를 다섯 글자로 표현하자면?",
        A:`안 그래도 돼\n "나도 내 앞가림 잘하고 나를 위해 희생하지 않아도 되고, 힘들어도 안 그런 척 하지 않았으면 좋겠는 동생의 마음. 우리는 부모없이 살았지만 나도 오빠를 챙길 수 있는 어른이 되었으니까"`
      },
      {
        Q:"커최몇? (커피 최대로 몇 잔 마실 수 있는지)",
        A:"커최몇이 무슨 소용이냐, 에너지 드링크 몇 캔을 먹어도 자고 싶을 때 바로 잠들 수 있는데 허허"
      },
    ]
  },
  {
    Name: "권소원",
    Image: "배우팀/권소원.jpg",
    Role: "윤지운",
    Words: "“성실하고, 능력있고, 잘생기고, 완벽한 개발자.”",
    Description:"<프로젝트 용궁>의 메인 개발자이자 인플루언서인 32세 지운은, 완벽한 남자가 되기 위해 SNS 안에서 자신을 꾸며낸다. 완벽하게 보여지려고 애쓸수록 자신의 빈 여백은 더 커져간다. 주위 사람들 역시 자신이 기억하는 각자의 지운을 그리워함으로써 정작 지운이의 속을 알아보려 하는 사람은 없자 지운은 점차 외로워져만 간다.",
    Questions:[
      {
        Q:"자기소개 부탁드립니다!",
        A:"안녕하세요 윤지운 역할을 맡은 31살 권소원입니다."
      },
      {
        Q:"인스타 라방할 때 시청자들과의 소통 꿀팁이 있다면?",
        A:"잘생긴 외모가 꿀팁일까요? 농담이고 진심을 담아 팬분들에게 대하는것이 꿀팁이라고 생각해요"
      },
      {
        Q:"프로그램 개발할 때 나만이 가진 습관이 있다면?",
        A:"너무 잠자는시간이 없다보니까 머리를 기대면 자는 습관이 생겼어"
      },
    ],
  },
  {
    Name: "이명선",
    Image: "배우팀/이명선.jpg",
    Role: "도은세",
    Words: "“영원히 사랑을 할래”",
    Description:"<프로젝트 용궁>의 메인 디자이너이자, 윤지운의 애인. 눈에 띄게 화려하진 않지만 미묘한 매력을 지녔다. 온화함 속에서도 이따금 엉뚱함, 발칙함, 그리고 확고한 주관이 보여진다. 은세는 모두에게 살갑지만 보이지 않는 선을 긋는데, 그 선 안으로 들어온 유일한 사람은 지운 뿐. 은세에게는 지운과 어릴 적부터 유일한 취미였던 그림, 그 둘이 전부이다.",
    Questions:[
      {
        Q:"자기소개 부탁드립니다!",
        A:"안녕하세요! 도은세 역할을 맡은 이명선입니다:)\n"
        +"<프로젝트 용궁>이 뮤지컬 입봉작이라 즐겁기도 떨리기도 한데요, 열심히 준비했으니 예쁘게 봐주세요ㅎㅎ"
      },
      {
        Q:"용궁 프로그램을 디자인할 때 가장 신경 쓴 점은?",
        A:"일단 총괄 디자이너 입장에서 말하자면 세계 최고 퀄리티의 가상현실이 구현되길 바랐기 때문에 리얼리티에 가장 많은 신경을 썼습니다.\n"
        +"그리고 개인적으로는 열심히 디자인한 캐릭터가 있는데ㅎㅎ 그게 뭘 지는 플레이해보시면 알 것 같아요.\n"
        +"용궁에서 가장 상징적인 캐릭터라 그 캐릭터만큼은 온전히 저 혼자 디자인했습니다."
      },
      {
        Q:"도은세가 보는 윤지운은 연애할 때 어떤 사람인지?",
        A:"지운오빠는 세심하고 다정다감한 사람이에요.\n"
        +"덕분에 한창 힘들던 시기에 자신감을 많이 얻었죠.\n"
        +"오빠 아녔으면 저 아마 디자인 쪽 일 안 했을 거예요.\n"
        +"근데 요새는 회사 일 때문인지 조금 지쳐보이네요…\n"
        +"아마 용궁 출시되면 좀 나아지겠죠?"
      },
    ],
  },
  {
    Name: "이주안",
    Image: "배우팀/이주안.jpg",
    Role: "이현서",
    Words: "“제가 준비한 2036, XPS 하반기 게임은 용궁입니다.”",
    Description:"게임회사 XPS의 그래픽디자이너 현서는, 회사 초창기부터 은세와 <프로젝트 용궁> 디자인팀에서 함께했다. 팀원들을 자연스럽고 편안하게 하는 매력을 가지고 있다. 주관이 뚜렷하며, 마음먹은 일을 실행에 옮기는 능력 역시 매우 뛰어나다. 현서는 윤지운의 자살 이후 위기에 빠진 XPS를 구하고자 <프로젝트 용궁>을 재가동하기로 결정한다.",
    Questions:[
      {
        Q:"자기소개 부탁드립니다!",
        A:"안녕하세요! 이현서 역을 맡은 배우 이주안입니다 :-)"
      },
      {
        Q:"짝사랑 경험이 있나요?",
        A:"음.. 아마 누구나 다 있지 않을까요..? "
      },
      {
        Q:"팀에서 가장 존경하는 팀원은?",
        A:"저는 저희 디자인 팀원들 모두 존경하지만, 굳이 한명을 꼽자면.. 도은세 씨요!"
      },
    ],
  },
  {
    Name: "전혜진",
    Image: "배우팀/전혜진.jpg",
    Role: "지성민/대장장이",
    Words: "“지금 용궁 운영 이어가는 건 리스크가 너무 커요.”",
    Description:"XPS의 직원인 지성민은 MBTI 대문자 T인 이성적인 사람이다. 윤지운의 자살로 <프로젝트 용궁>에 큰 문제가 생겼을 때에도 현실적으로 사고하고 해결 방안을 제시한다. 다수에게는 차갑고 정이 없어 보이지만, 가깝다고 느끼는 소수에게는 따뜻한 해결사인 그녀. 성실함과 책임감이 최대의 강점인 지성민은 팀원들과 이 위기를 잘 이겨내고 싶어한다.",
    Questions:[
      {
        Q:"자기소개 부탁드립니다!",
        A:"안녕하세요 뮤지컬 [프로젝트 용궁: 낙원의 미스테리]에서 지성민 역, 대장장이 역을 맡은 전혜진입니다.\n"
        +"오디션 공고에 쓰인 사람과 구별할 수 없는 인공지능 게임이라는 배경에 흥미를 느껴 지원 하게 되었고 지난 두 달간 즐겁게 연습하였습니다. 관람하시는 모든 분들께도 이 공연이 즐거움과 생각할 무엇인가로 다가가길 바라며 많은 관심과 응원 부탁드립니다:)"
      },
      {
        Q:"회사에 출근해서 가장 먼저 하는 루틴이 있다면?",
        A:"컴퓨터를 켜고 서랍에서 물티슈를 한 장 꺼내어 제 책상에 먼지를 닦고 업무를 시작합니다. 컴퓨터를 켜서 가장 먼저 하는 일은 포털 사이트에서 게임 관련 이슈를 검색해 보는 일입니다."
      },
      {
        Q:"일할 때 어떤 스타일이 제일 싫어요?",
        A:"충분히 토의하고 인지했던 일 이야기를 반복해서 꺼내는 스타일, 일정이나 효율적인 과정을 생각하지 않고 아이디어를 제시하는 스타일입니다."
      },
    ],
  },
  {
    Name: "김다위",
    Image: "배우팀/김다위.jpg",
    Role: "유광희/미역농부",
    Words: "“집에 우리 뽀삐가 형아를 오매불망 기다려요”",
    Description:"게임회사 XPS의 직원 광희는 옆에서 보아도 바로 알 수 있을 만큼 말과 행동에서 그날의 기분이 드러나는 인물이다. 처지거나 답답한 것을 싫어하지만, 어느 정도 눈치가 있는 편이기에 회사생활에서의 선은 잘 지키는 편이다. 생각나면 뭐든 던지고 보는 성격이라 회사 일에 반영되는 아이디어는 일부분이지만, 심각한 상황에서도 심각해지지 않으려 노력한다.",
    Questions:[
      {
        Q:"자기소개 부탁드립니다!",
        A:"노래 가르치고 공연도 하는 김다위입니다. 소개하라고 하면 되게 잘 할 줄 알았는데 생각보다 어렵네요. 프로젝트 용궁에서 유광희 역을 맡고 있습니다. 재미있는 사람은 아니지만 재미있게 연기하도록 많이 노력했으니 재미있게 봐주시면 감사하겠습니다!"
      },
      {
        Q:"재밌는 얘기 하나만 해주세요",
        A:"이건 비밀인데, 지금 개발 중인 프로젝트 용궁 메인 NPC 용왕을 윤지운 팀장 얼굴로 만든대요. 그럼 제가 팀장이었으면 용왕을 제 얼굴로 만들 수도 있었던 거 아니에요? 그게 좀 더 괜찮을 것 같은데, 맞죠? 몇년만 빨리 입사했어도........"
      },
      {
        Q:"요즘 밀고 있는 유행어가 있다면?",
        A:"제가 말하면 다 유행어 되는거죠 뭐. 뭘 그런걸 물어보고 그러세요 ㅎㅎ 그러니까...요즘 밀고 있는 게....어... 그... 용궁 오픈하면 그때 보시면 다 알아요!"
      },
    ],
  },
  {
    Name: "정세영",
    Image: "배우팀/정세영.jpg",
    Role: "소시연/연금술사",
    Words: "“벌써 2년이나 지나긴 했지만, 전 그래도 무서워요.”",
    Description:"소심해서 목소리도 작고 주위 눈치를 많이 보는 XPS 직원이다. 자신의 주관보다는 여론을 많이 신경 쓰고, 걱정하는 편이다. 회사의 도전적인 결정에 우려를 내비치기도 한다. 그렇지만 배려심이 깊고 섬세하기에 팀원들을 누구보다도 걱정해주고 신경 쓴다. 혼란스러운 회사 상황 속 양가의 입장을 다 이해되며 마음이 복잡해진다.",
    Questions:[
      {
        Q:"자기소개 부탁드립니다!",
        A:"안녕하세요 변화'무쌍'한 배우 정세영입니다. 1인 3역을 맡게되어 아주 바쁜데, 캐릭터마다 다른 매력을 발견할 수 있으실거에요"
      },
      {
        Q:"새로운 프로젝트를 개발 중에 있다고 들었는데, 순조롭게 진행되고 있나요?",
        A:"국내 최고의 가상현실을 구현하기위해 끝없는 오류를 경험하고 이겨내려고 모두 노력하고 있어요! 그리고 제가 그 팀에 속해있다는게 믿기지 않을정도로 행복해요 "
      },
      {
        Q:"요즘 회사 분위기 어떤가요?",
        A:"메인개발자님과 디자이너님 두 분이 분위기가 안좋아요.. 크게 싸우지 않고 더욱 집중해서 프로젝트 용궁이 완성도 있게 나왔으면 좋겠어요!"
      },
    ],
  },
  {
    Name: "이준성",
    Image: "배우팀/이준성.jpg",
    Role: "해청/용사",
    Words: "“그자는 지금 어디있나. 어서 용왕님께 인사드리도록 하게”",
    Description:"해청은 용궁의 재상이자 심복으로서 업무를 보며 지낸다. 용왕이 왕위에 오르기 전부터 봐왔기에 용왕과 제일 친한 사이이며, 용왕 다음으로 높은 권력을 가지고 있다. 평소에는 용왕 근처에서 업무를 보다가도 용궁의 주요 행사는 해청이 주관하는 편이다. 매사 점잖아 보이는 해청이지만, 용왕과 함께할 때는 케미를 발산하며 편한 모습을 드러내기도 한다.",
    Questions:[
      {
        Q:"자기소개 부탁드립니다!",
        A:"안녕하세요. 이번 뮤지컬 용궁에서 해청 역할을 맡게된 이준성이라고 합니다."
      },
      {
        Q:"본인이 용왕에게 어떤 존재라고 생각하는지?",
        A:"믿음직한 동료이자 어디로 튈지모르는 골칫덩어리같은 존재죠."
      },
      {
        Q:"최근 용궁에 골칫거리가 나타났다던데?",
        A:"다른 사람들은 반용궁 조직이라고 하는데 도대체 용왕님이 어디다 뭘 숨기셨는지 저한테는 말도 안하시고 매일밤 몰래 어딜다녀오시는데 저는 이게 더 골칫거리입니다. 여자라도 숨겨놓으셨는지..."
      },
    ],
  }
]

export const DancerData = [
  {
    Name: "김나영",
    Image: "안무팀/김나영.jpeg",
    Insta: "steam_young_",
    Words:"아주아주 멋진 분들이 다함께 만들어 나가는 무대! 그 일부가 될 수 있어 무척 영광입니다 ; ) 즐겁게 봐주세요~",
  },
  {
    Name: "김시연",
    Image: "안무팀/김시연.jpeg",
    Insta: "siyeon1845",
    Words:"많은 분들의 노력으로 완성된 멋있는 뮤지컬에 함께 할 수 있어서 영광입니다👍 안무팀 짱💕",
  },
  {
    Name: "박수빈",
    Image: "안무팀/박수빈.jpeg",
    Insta: "clxp._.bxxn_",
    Words:"연출된 뮤지컬을 보기만 했었는데 좋은 기회로 무대에 서보게 되어서 감회가 새롭네요😆 고어헤드의 망나니(?) 칼춤 기대해주세요!!",
  },
]